import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import axios from 'axios';

import * as Survey from 'survey-react'

var defaultThemeColors = Survey
.StylesManager
.ThemeColors["default"];
  
function abortSurvey() {
    console.log('abortSurvey')
    this.survey.completedHtml = "<h2>Wij hopen dat u naar tevredenheid bent geholpen.</h2>";
   this.survey.isAborted = true;
    this.survey.doComplete();
  }


  Survey.JsonObject.metaData.addProperty("question", {
    name: "AssignTitle",
    type: "boolean",
    defaultValue: false
  });
  
  function getTitle(params) {
    console.log('getTitle',params)
    if (!params && params.length < 1) return -1;
    var question = this.survey.getQuestionByName(params[0]);
    return question
  }
  

    function getQuestionDisplayValueByTitle(params) {
        if (!params && params.length < 1) return -1;
        var question = this.survey.getAllQuestions().filter(function(q) {
             return q.title === params[0]; })[0];
             return !!question && question.displayValue;
    }

  Survey.FunctionFactory.Instance.register("abortSurvey", abortSurvey);  
 
  Survey.FunctionFactory.Instance.register(
    "getQuestionDisplayValueByTitle",
    getQuestionDisplayValueByTitle,
  );
  Survey.FunctionFactory.Instance.register(
    "getTitle",
    getTitle
  );


class EnqueteView extends React.Component {
 
   state = {
       count:0
   }
    constructor(){
        
        super();
        this.state={
            survey: {},
            isLoading: true
         }
        
        }

    mapChoice = (choice) => 
    {
        const { ID,Omschrijving } = choice   
        
          return (
           { value: ID,
            text: Omschrijving
         }
        )
    }

    RadioButtonQuestion = (title, choices,id)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            name: JSON.stringify(id), 
            title
        }        
    }
    checkboxQuestion = (title, choices,id)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            name: JSON.stringify(id), 
            title
        }        
    }
    TextboxQuestion = (title, choices,id)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            name: JSON.stringify(id), 
            
            title
        }        
    }
    DropdownQuestion = (title, choices, id)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            requiredErrorText:'Maak een keuze',
            name: JSON.stringify(id),
            title
        }        
    }
    mapQuestion = (question,pageIndex,logo,text) => {
         if (pageIndex === 1) {
            
            return {
                type: 'html',
                html: question.Omschrijving          //'<img src="data:image/jpeg;base64,' + logo + '"><br><br>' + text
            
            }
        }
        const {Antwoorden,Omschrijving,ID} = question
        //console.log('pageIndexxx',pageIndex)
        //console.log(question.TypeObject)
        switch (question.TypeObject) {
           
            case 'RadioButtons':
                return this.DropdownQuestion(Omschrijving, Antwoorden,ID);        
            
            case 'TextBox':
        
               return {
                type: "text",
                name: JSON.stringify(ID),
                title: Omschrijving,
                visibleIf: "getQuestionDisplayValueByTitle('Heeft u nog aanvullende op- of aanmerkingen?')='Ja'",
               }

            case 'DropDown':
                return this.DropdownQuestion(Omschrijving, Antwoorden,ID); 
                default:
                return {}; 
                 
               
        }
        

   
    }

   
    
    createPages = (pages,logo,text) => {
       
        let pageIndex = 0
        
        return pages.map(page => {
                
            pageIndex++;
            
            return {
                    name:(`page${pageIndex}`),
                    questions: [(this.mapQuestion(page,pageIndex,logo,text))]
                 
                }
        })
    
    }
  

    mapResponseToState = (data,id) => {
                 const { ID,VragenLijst,EnqueteName,StartPagina } = data
                  const result = 
                   {
                                    ID: ID,
                                    title: EnqueteName,                                   
                                    triggers: [
                                       // {
                                       //     type: "runexpression",
                                       //     expression: "getQuestionDisplayValueByTitle('Wenst u deel te nemen aan deze tevredenheid meting of toekomstige tevredenheid meting uitgevoerd in opdracht van Univé verzekeringen?')=Nee",
                                       //     runExpression: "abortSurvey()"
                                      
                                       // },
                                        {
                                            type: "runexpression",
                                            expression: "getQuestionDisplayValueByTitle('Wenst u deel te nemen aan dit klanttevredenheid onderzoek?')=Nee",
                                            runExpression: "abortSurvey()"
                                         },
                                        {
                                            type: "runexpression",
                                            expression: "getQuestionDisplayValueByTitle('Wenst u deel te nemen aan deze tevredenheidmeting of toekomstige tevredenheidmetingen uitgevoerd in opdracht van Nefkens Pechhulp?')=Nee",
                                            runExpression: "abortSurvey()"
                                        },
                                        {
                                            type: "runexpression",
                                            expression: "getQuestionDisplayValueByTitle('Wenst u deel te nemen aan deze tevredenheidmeting of toekomstige tevredenheidmetingen uitgevoerd in opdracht van Terwolde Pechhulp?')=Nee",
                                            runExpression: "abortSurvey()"
                                         },
                             
                                    ],
                                    pages: this.createPages(VragenLijst,StartPagina.Logo,StartPagina.Text),
                                    bgcolor: StartPagina.KleurAchtergrond
                                             
                                           
                   }
                   //console.log('result',result)
                   console.log('JSONresult',JSON.stringify(result))
                   return result
                   
    }

    componentDidMount = async() => {
        console.log('componentdidmount')
        
        const { id } = this.props.match.params
       
                   const url = `/api/survey/${id}`;
                   try {
                    const response = await axios.get(url)
                    console.log("Api: ",response.data)
                    console.log("Apipadres: ",response.ip)
                    this.setState({survey: this.mapResponseToState(response.data,id), isLoading: false, id,completedHtml:response.data.AfsluitText});                    
                    
                   defaultThemeColors["$header-background-color"] = response.data.StartPagina.KleurAchtergrond
                   defaultThemeColors["$text-color"] = response.data.StartPagina.KleurText 
                   }
                   catch (error)
                   {
                       this.setState({survey: 
                        { 
                            mode: 'display',
                            "pages": [
                                {
                                    "name": "page1",
                                    "elements": [
                                        {
                                            "type": "html",
                                            "name": "fout",
                                            "html": `<p>${error.response.data.Message}</p>`
                                        }
                                    ]
                                }
                            ]
                        }, isLoading: false, id,
                        completedHtml:error.response.data.Message});                    
                   }
                   
                   Survey
                   .StylesManager
                   .applyTheme();
                  
                }

    
    createResponse = (list) => {
       var result = []

        Object.keys(list).forEach(function(key) {
            result.push(
            {
                "OpenText": null,
                "isOpenText": false,
                "AntwoordID": list[key],
                "VraagID": parseInt(key)
            })
        })

        return result;
    }    
            

    handleSurveyComplete = (sender, options) => {
        //console.log(sender.isAborted)
        const respons = {
            queueID: this.props.match.params,
            mobileGeenEnquete: sender.isAborted,
            ontvangenAntwoorden:  this.createResponse(sender.data)
          }
        const url="/api/survey/" + respons.queueID.id
        console.log('naarurl: ',url)
        const response = axios.put(url,respons)
        console.log('response: ',response)
        console.log('respons (wat wordt verzonden): ',JSON.stringify(respons))   
    }

    render() {
            
            const {survey, isLoading, completedHtml} = this.state;
            console.log('state',this.state)
            survey.pageNextText = 'Volgende'
            survey.pagePrevText = 'Vorige'
            survey.completeText = 'Afronden'
            survey.completedHtml = completedHtml
           
        return (
            isLoading ? 'loading...': 
            <Survey.Survey 
            json={survey} 
            onComplete={ this.handleSurveyComplete }
             />  
         
        )
                       
                   
    }

}

export default EnqueteView
